import { render, staticRenderFns } from "./IndexTabContainer.vue?vue&type=template&id=9fc68a0a&"
import script from "./IndexTabContainer.vue?vue&type=script&lang=js&"
export * from "./IndexTabContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports